import * as React from 'react';

const RESPONSIVE_CUTOFF = 768;

export interface ResponsiveState {
  isMobile: boolean;
}

export const ResponsiveContext = React.createContext<ResponsiveState>({
  isMobile: isWindowMobile(),
});

export class Responsive extends React.Component<React.PropsWithChildren, ResponsiveState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      isMobile: isWindowMobile(),
    };
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  render() {
    return <ResponsiveContext.Provider value={this.state}>{this.props.children}</ResponsiveContext.Provider>;
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
  }

  private updateDimensions = () => {
    const currentScreenState = isWindowMobile();
    if (this.state.isMobile !== currentScreenState) {
      this.setState({
        isMobile: currentScreenState,
      });
    }
  };
}

function isWindowMobile() {
  return isMobile(document.body.clientWidth);
}

function isMobile(width: number) {
  return width <= RESPONSIVE_CUTOFF;
}

export const withResponsive =
  <T extends object>(WrappedComponent: React.ComponentType<React.PropsWithChildren<T & ResponsiveState>>) =>
  (props: T) =>
    (
      <ResponsiveContext.Consumer>
        {(responsiveContext) => <WrappedComponent {...props} {...responsiveContext} />}
      </ResponsiveContext.Consumer>
    );

export const useResponsive = () => React.useContext(ResponsiveContext);
